import React from 'react';
import css from './AdminCard.module.css';

interface AdminCardProps {
  flexDirection?: 'row' | 'column';
  secondaryClass?: string;
  noPadding?: boolean;
  noBorder?: boolean;
  noShadow?: boolean;
  title?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

const AdminCard: React.FC<AdminCardProps> = ({
  flexDirection = 'column',
  secondaryClass,
  noPadding = false,
  noBorder = false,
  noShadow = false,
  title,
  onClick,
  children,
}) => {
  const containerClasses = [
    css.card,
    flexDirection === 'row' ? css.cardRow : css.cardColumn,
    noPadding ? css.noPadding : '',
    noBorder ? css.noBorder : '',
    noShadow ? css.noShadow : '',
    secondaryClass,
  ]
    .filter(Boolean)
    .join(' ');

  const titleElement = title ? (
    <header className={css.cardTitle}>{title}</header>
  ) : null;

  return (
    <div className={containerClasses} onClick={onClick}>
      {titleElement}
      <div className={css.cardBody}>{children}</div>
    </div>
  );
};

export default AdminCard;